import { Comedian } from "./comedian";

export const returnRankedUnfollowedComedians = ({
  allComedians,
  followedComedians,
  comedianRankingScores,
}: {
  allComedians: Comedian[];
  followedComedians: {
    comedian_id: string;
  }[];
  comedianRankingScores: { comedian_id: string; score: number }[];
}) => {
  const followedComedianIds = followedComedians.map(
    (comedian) => comedian.comedian_id
  );

  const unfollowedComedians = allComedians.filter(
    (comedian) => !followedComedianIds.includes(comedian.id)
  );

  const comedianScoreMap = comedianRankingScores.reduce<{
    [key: string]: number;
  }>((map, score) => {
    map[score.comedian_id] = score.score;
    return map;
  }, {});

  const sortedUnfollowedComedians = unfollowedComedians.sort((a, b) => {
    const rankA = comedianScoreMap[a.id];
    const rankB = comedianScoreMap[b.id];
    return rankB - rankA;
  });

  return sortedUnfollowedComedians;
};
